import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from '@/interface/axiosInstance'
import store from './store'
import qs from 'qs'
// import service from './interface/axiosInstance'

const app = createApp(App)
app.use(router)
app.use(store)


app.mount('#app')
app.config.globalProperties.$axios = axios; // 全局引用
app.config.globalProperties.$qs = qs;

